import axios from "axios";
import i18next from "i18next";

axios.defaults.baseURL = "https://aldahayan.net/api";
//axios.defaults.baseURL = "https://localhost:7022/api";

axios.interceptors.request.use(
  (config) => {
    config.headers["Accept-Language"] = i18next.language;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);
